export const operationTypeNames = {
  INSERT: 'Create',
  UPDATE: 'Update',
  DELETE: 'Delete',
} as const;

export type TransformedLogChange = {
  id: string;
  column: string;
  originalValue: { id: string | null; value: string };
  newValue: { id: string | null; value: string };
};
export type TransformedLog = {
  id: string;
  operationTimestamp: string;
  operationType: string;
  userEmail: string | null;
  changes: TransformedLogChange[];
  /** Comma-joined display names of changed columns (truncated with "+N more"). */
  changedColumnsLabel: string;
};
